import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import {
  CONSOLE,
  consoleProvider,
  GlobalErrorHandlerService,
  HIGHCHARTS_LAZY,
  highchartsLazySingleton,
  HLS_LAZY,
  hlsLazySingleton,
  LOCALES_LAZY,
  localesLazySingleton,
  NAVIGATOR,
  navigatorProvider,
  NUM_RESULTS_PER_PAGE,
  NUM_TILE_RESULTS_PER_PAGE,
} from '@degreed/lxp/services';
import { AVATAR_FONT_FAMILY } from './components/profile-pic/profile-pic.component';

// services

/*********************************************************************************
 * NOTE: This is a providers only shared module intended to be loaded in the
 *       `app.module`.  Do not lazy-load this module.
 *********************************************************************************/

/*********************************************************************************
 * NOTE: Only list providers that cannot be marked with:
 *       `Injectable({ providedIn: 'root'})` here
 *********************************************************************************/

// variables
const bodyFontFamily = window.getComputedStyle(
  document.querySelector('body')
).fontFamily;

const NUM_RESULTS_PER_PAGE_VALUE = 20;
const NUM_TILE_RESULTS_PER_PAGE_VALUE = 12;

@NgModule({
  providers: [
    // angular pipe
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    { provide: HIGHCHARTS_LAZY, useFactory: highchartsLazySingleton },
    { provide: LOCALES_LAZY, useFactory: localesLazySingleton },
    { provide: HLS_LAZY, useFactory: hlsLazySingleton },
    { provide: CONSOLE, useFactory: consoleProvider },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: NAVIGATOR, useFactory: navigatorProvider },
    { provide: AVATAR_FONT_FAMILY, useValue: bodyFontFamily },
    { provide: NUM_RESULTS_PER_PAGE, useValue: NUM_RESULTS_PER_PAGE_VALUE },
    {
      provide: NUM_TILE_RESULTS_PER_PAGE,
      useValue: NUM_TILE_RESULTS_PER_PAGE_VALUE,
    },
  ],
})
export class SharedProvidersModule {}
